import AppConstants from '../../../../config/app.constants';

class FinalResidualCountCommitController {
  /*@ngInject*/
  constructor(Auth, $state, User, DataCounter, $translate, $q, Modal, $scope, DateUtil, SetupService, Navigation, UsersService, BranchFundingSourceService, AtmResidualService, DenominationService, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$q = $q;
    this.Modal = Modal;
    this.DataCounter = DataCounter
    this.$scope = $scope
    this.SetupService = SetupService;
    this.DateUtil = DateUtil;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.BranchFundingSourceService = BranchFundingSourceService;
    this.AtmResidualService = AtmResidualService;
    this.DenominationService = DenominationService;
    this.$rootScope = $rootScope;
    this.model = {
      loading: false,
      search: null,
      branch: User.getUser().branchId,
      totalLocationRecords: 0,
      fundingSourceList: [],
      residualCountCommitList: [],
      totalUsers: 0,
      userList: [],
      pagination: {
        page: 1,
        total: 0,
        pageLimit: 30,
        maxPages: 10,
      },
      paginationDeposit: {
        page: 1,
        total: 0,
        pageLimit: 30,
        maxPages: 10
      },
      gettingResidualShipment: false,
      gettingDepositShipment: false,
      residualTrackingIds: [],
      depositTrackingIds: [],
      loggedInUser: User.getUser().id,
      authorizeCountCommit: false,
      currentStats: 'pending',
      statsObj: {
        pending: 'pending',
        authorized: 'authorized'
      },
      denomsList: [],
      residualsCompletedApprovalList: [],
      depositsCompletedApprovalList: [],
      gettingResidualCompletedApprovalList: false,
      dateRangeOption: {
        startDate: null,
        endDate: null,
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {},
      searchText: '',
      isExportingAuthorizedResidual: false,
      isDepositsAuthorizedResidualExporting: false,
      browserTimezone: moment.tz.guess()
    };

    this.toggleSelect = false;
    this.depositToggleSelect = false;
    this.sortColumn = "row";
    this.reverseSort = false;
    this.depositSortColumn = "row";
    this.depositReverseSort = false;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/final-residual-count-commit');
  }

  $onInit() {
    this.dataObj = this.DataCounter.getData();

    this.$q.all([
      this.SetupService.get(this.model.branch),
      this.loadAllDenomination()
    ])
      .then((data) => {
        this.currentVaultDate = this.DateUtil.getUTCDate(data[0].currentVaultDate);
        this.setDateRangeOptions(this.currentVaultDate, 'dateRangPickerOptionsfor');
        this.model.dateRangeOption.startDate = moment(this.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        this.model.dateRangeOption.endDate = moment(this.currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss');

        this.getFundingSource('', 0).then(() => {
          this.autoSetOrLoadData();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  locationSearchObj = (searchKey) => {
    searchKey = searchKey || '';
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: this.model.branch
          },
          {
            group: {
              rules: [{
                field: 'locationId',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'sourceName',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  getFundingSource(searchKey, offset) {
    const loadLocationData = this.locationSearchObj(searchKey);
    return this.BranchFundingSourceService.all(loadLocationData, offset, AppConstants.defaultPageLimit)
      .then((data) => {
        if (offset === 0) {
          this.model.totalLocationRecords = data.total;
          this.model.fundingSourceList = this.mappingLocationData(data.results);
        }
        else {
          const locations = this.mappingLocationData(data.results);
          this.model.fundingSourceList = this.model.fundingSourceList.concat(locations);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  mappingLocationData(locations) {
    return locations.map((data) => {
      return {
        Key: data.locationId + " | " + data.sourceName,
        Value: data.locationId,
        Id: data.id
      }
    });
  }

  getResidualsCountCommit() {

    if (!this.model.fundingSource) {
      this.model.residualCountCommitList = [];
      return;
    }

    let startDate = !this.toggleSelect ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
    let endDate = !this.toggleSelect ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;

    this.model.gettingResidualShipment = true;
    this.model.gettingDepositShipment = true;
    let denoms = [];
    const userId = this.model.user && this.model.user.Value ? this.model.user.Value : null
    if (this.model.denoms && this.model.denoms.length ) {
      this.model.denoms.forEach(item => {if (item.ticked) {denoms.push(item.Value)}})
    }
    return this.AtmResidualService.getResidualsCountCommit(this.model.searchText, this.model.fundingSource.Id, startDate, endDate, denoms, userId)
      .then((data) => {
        if (data && this.allDenominations) {
          if (data.atmDenomSummary && Array.isArray(data.atmDenomSummary)) {
            data.atmDenomSummary.forEach(summary => {
              const denom = this.allDenominations.find(d => d.id === summary.denominationId);
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          if (data.depositDenomSummary && Array.isArray(data.depositDenomSummary)) {
            data.depositDenomSummary.forEach(summary => {
              const denom = this.allDenominations.find(d => d.id === summary.denominationId);
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
        }
        this.model.residualCountCommitList = data;
        // this.model.pagination.total = data.totalRecords;
        this.resetFilter();
        // this.model.residualCountCommitList.results.forEach(shipment => {
        //   if (this.model.residualTrackingIds.includes(shipment.trackingId)) { shipment.isSelected = true; }
        // });
        // console.log(this.model.residualCountCommitList);
      })
      .catch((err) => {
        console.log(err);
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.model.gettingResidualShipment = false;
        this.model.gettingDepositShipment = false;
      })
  }

    showDenomBreakdown(data) {
        this.AtmResidualService.getDepositDenominationBreakdown(data.orderNo, data.trackingId, data.locationId, data.countVaultDate)
            .then((denoms) => {
                this.Modal.denominationBreakdownModal({
                    denomData: denoms,
                    orderNo: data.orderNo || data.trackingId,
                    locationId: data.locationId,
                    countVaultDate: data.countVaultDate,
                    statedTotalAmount: data.statedTotalAmount,
                    amountCounted: data.amountCounted,
                    countedVariance: denoms.length == 1 ?data.amountVariance : null,
                });
            })
            .catch((err) => {
                console.log(err);
                this.Modal.errorModal(err.data.message);
            });
    }

  goToUserTab(userId) {
    if (!userId) return;
    this.Navigation.goToUserTab(userId, null);
  }

  goToServiceHistory(locationId) {
    if (!locationId) return;
    this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  goToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

  goToOrderHistory(data) {
    return this.Navigation.goToOrderHistory(data.orderNo, null, true, true, false, false, null, this.model.fundingSource.Id);
  }

  pageChange() {
    this.model.residualTrackingIds = [];
    this.model.depositTrackingIds = [];
    this.loadData();
  }

  goToATMCount(data) {
    return this.Navigation.goToAtmCount(data.parentTrackingId, true, null, this.model.fundingSource.Id)
  }

  goToATMCountOfDeposit(data) {
    const trackingId = data.parentTrackingId ? data.parentTrackingId : data.trackingId;
    return this.Navigation.goToAtmCount(trackingId, true, null, this.model.fundingSource.Id)
  }

  selectedResiduals(event, data, index) {
    if (event.target.checked) {
      this.model.residualTrackingIds.push(data.trackingId);
    }
    else {
      const index = this.model.residualTrackingIds.indexOf(data.trackingId);
      this.model.residualTrackingIds.splice(index, 1);
    }
  }
  selectedDepositResiduals(event, data, index) {
    if (event.target.checked) {
      this.model.depositTrackingIds.push(data.trackingId);
    }
    else {
      const index = this.model.depositTrackingIds.indexOf(data.trackingId);
      this.model.depositTrackingIds.splice(index, 1);
    }
  }

  getComments(data) {
    this.Modal.confirm({
      header: this.$translate.instant('common.comment'),
      message: data.comment,
      callback: (({
        modal
      }) => {
        modal.close();
      }),
      negative: (({
        modal,
      }) => {
        modal.close();
      }),
      buttons: ['common.close'],
      type: 'success'
    })
  }

  reset() {
    this.model.residualTrackingIds = [];
    this.model.depositTrackingIds = [];
    this.model.pagination.page = 1;
    this.model.paginationDeposit.page = 1;
  }

  toggleAllResidualSelection() {
    this.model.residualTrackingIds = [];
    this.model.residualCountCommitList.results.forEach(shipment => {
      if (this.toggleSelect) {
        shipment.isSelected = this.toggleSelect;
        this.model.residualTrackingIds.push(shipment.trackingId)
      }
      else {
        shipment.isSelected = this.toggleSelect;
        this.model.residualTrackingIds = [];
      }
    });
    // this.toggleSelect = !this.toggleSelect;
  }
  toggleAllDepositSelection() {
    this.model.depositTrackingIds = [];
    this.model.residualCountCommitList.countedDeposits.forEach(shipment => {
      if (this.depositToggleSelect) {
        shipment.isDepositSelected = this.depositToggleSelect;
        this.model.depositTrackingIds.push(shipment.trackingId)
      }
      else {
        shipment.isDepositSelected = this.depositToggleSelect;
        this.model.depositTrackingIds = [];
      }
    });
  }

  loadData() {
    this.getResidualUsers('', 0);
    if (this.model.currentStats === this.model.statsObj.pending) return this.getResidualsCountCommit();
    else if (this.model.currentStats === this.model.statsObj.authorized) return this.getResidualsCompletedApproval();
  }

  autoSetOrLoadData() {
    let findFundingSource;
    this.model.currentStats = this.model.statsObj.pending;

    if ((this.dataObj && this.dataObj.isRedirected) || (this.model.fundingSourceList.length === 1)) {
      if (this.dataObj) {
        findFundingSource = _.find(this.model.fundingSourceList, { Value: this.dataObj.fundingSourceLocation });
      }
      this.model.fundingSource = {
        Key: findFundingSource ? findFundingSource.Key : this.model.fundingSourceList[0].Key,
        Value: findFundingSource ? findFundingSource.Value : this.model.fundingSourceList[0].Value,
        Id: findFundingSource ? findFundingSource.Id : this.model.fundingSourceList[0].Id,
      }
      this.loadData();
    }
  }

  resetFilter() {
    if (this.dataObj) {
      this.dataObj.isRedirected = false;
      this.dataObj = this.DataCounter.setData();
    }
  }

  validateSupervisorScan(sectionType) {
    this.UsersService.checkSupervisor(this.model.loggedInUser).then((userInfo) => {
        if (userInfo && userInfo.supervisor) {
          return this.bulkAuthorize(userInfo.id, sectionType);
        }
        else {
          this.Modal.confirmSupervisor('bulk-authorize-count-commit', null, ({ modal, supId }) => {
            modal.close();
            return this.bulkAuthorize(supId, sectionType);
          }, ({ modal }) => {
            modal.close();
            this.isLoading = false;
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
        this.Modal.errorModal(err.data.message);
      })
  }

  bulkAuthorize(userId, sectionType) {
    let denoms = [];
    if (this.model.denoms && this.model.denoms.length ) {
      this.model.denoms.forEach(item => {if (item.ticked) {denoms.push(item.Value)}})
    }
    this.model.authorizeCountCommit = true;
    let user =  this.model.user && this.model.user.Value ? this.model.user.Value : null
    let startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00');
    let endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59');
    (sectionType === 'deposit' ? this.AtmResidualService.authorizeDepositsCount(this.model.fundingSource.Id, this.model.branch, userId, this.model.searchText,startDate, endDate, user, denoms) : this.AtmResidualService.authorizeResidualCount(this.model.fundingSource.Id, this.model.branch, userId))
      .then((data) => {
        this.loadData();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        } else {
          this.Modal.errorModal(err);
        }
      })
      .finally(() => {
        this.model.authorizeCountCommit = false;
      })
  }

  tabSelection(selectedValue) {
    this.toggleSelect = false;
    this.depositToggleSelect = false;
    this.reverseSort = false;
    this.sortColumn = "row";
    this.depositReverseSort = false;
    this.depositSortColumn = "row";
    this.model.stats = selectedValue;
    this.model.user = null;
    this.reset();
    this.loadData();
  }

  onFundingSourceChange() {
    this.resetSearchText();
    this.reset();
    this.model.user = null;
    this.getResidualUsers('', 0);
    this.getResidualsCountCommit();
    this.getResidualsCompletedApproval();
  }

  onDateRangeChange() {
    this.reset();
    this.model.user = null;
    this.loadData();
  }

  getResidualsCompletedApproval() {

    if (!this.model.fundingSource) {
      this.model.pagination.page = 1;
      this.model.paginationDeposit.page = 1;
      this.model.residualsCompletedApprovalList = [];
      this.model.depositsCompletedApprovalList = [];
      return;
    }

    let startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00');
    let endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59');

    this.model.gettingResidualCompletedApprovalList = true;
    setTimeout(() => {
      let denoms = [];
      let userId = this.model.user && this.model.user.Value ? this.model.user.Value : null;
      if (this.model.denoms && this.model.denoms.length ) {
        this.model.denoms.forEach(item => {if (item.ticked) {denoms.push(item.Value)}})
      }
      const depositOffset = (this.model.paginationDeposit.page - 1) * this.model.paginationDeposit.pageLimit;
      const atmOffset = (this.model.pagination.page - 1) * this.model.pagination.pageLimit;
      const depositLimit = this.model.paginationDeposit.pageLimit;
      const atmLimit = this.model.pagination.pageLimit;
      this.AtmResidualService.getResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, moment.tz.guess(), startDate, endDate, denoms, userId, atmOffset, atmLimit, depositOffset, depositLimit)
        .then((data) => {
          if (data && data.atmDenomSummary && Array.isArray(data.atmDenomSummary) && this.allDenominations) {
            data.atmDenomSummary.forEach(summary => {
              const denom = this.allDenominations.find(d => d.id === summary.denominationId);
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          this.model.residualsCompletedApprovalList = data;
          this.model.pagination.total = data.totalRecords;
        })
      this.AtmResidualService.getDepositsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, moment.tz.guess(), startDate, endDate, userId, denoms, depositOffset, depositLimit)
        .then((data) => {
          if (data && data.depositDenomSummary && Array.isArray(data.depositDenomSummary) && this.allDenominations) {
            data.depositDenomSummary.forEach(summary => {
              const denom = this.allDenominations.find(d => d.id === summary.denominationId);
              if (denom) {
                summary.sortOrder = denom.sortOrder;
                summary.faceValue = denom.faceValue;
              }
            });
          }
          this.model.depositsCompletedApprovalList = data;
          this.model.paginationDeposit.total = data.totalCountedDepositsRecords;
        })
        .catch((err) => {
          console.log(err);
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
          else {
            this.Modal.errorModal(err);
          }
        })
        .finally(() => {
          this.model.gettingResidualCompletedApprovalList = false;
        })
    })
  }

  setDateRangeOptions(date, modelValue) {
    let currentVaultDate = moment(date).format() || moment();
    this.model[modelValue] = {
      autoApply: true,
      eventHandlers: {
        'apply.daterangepicker': () => {
          if (this.model.currentStats === this.model.statsObj.pending) { this.toggleSelect = false; }
          this.reset();
          this.loadData();
        }
      },
      ranges: {
        'Today': [
          moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Week': [
          moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Month': [
          moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Past 30': [
          moment(currentVaultDate).subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Past 60': [
          moment(currentVaultDate).subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Past 90': [
          moment(currentVaultDate).subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Year': [
          moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ]
      }
    }
  }

  sortData(column) {
    this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
    this.sortColumn = column;
  }

    sortDepositData(column) {
    this.depositReverseSort = (this.depositSortColumn == column) ? !this.depositReverseSort : false;
    this.depositSortColumn = column;
  }

  resetSearchText() {
    this.model.searchText = '';
  }

  selectAllPendingResiduals() {
    this.toggleSelect = !this.toggleSelect;
    if (this.toggleSelect) {
      this.resetSearchText();
    }
    this.getResidualsCountCommit().then(() => {
      this.toggleAllResidualSelection();
    });
  }

  selectAllPendingDeposits() {
    this.depositToggleSelect = !this.depositToggleSelect;
    // if (this.depositToggleSelect) {
    //   this.resetSearchText();
    // }
    this.getResidualsCountCommit().then(() => {
      this.toggleAllDepositSelection();
    });
  }

  assertToggleSelection() {
    if (this.model.searchText) this.toggleSelect = false;
  }
  
  assertDepositToggleSelection() {
    if (this.model.searchText) this.depositToggleSelect = false;
  }

  printAuthorizedResidual() {
    let denoms = [];
    if (this.model.denoms && this.model.denoms.length ) {
      this.model.denoms.forEach(item => {if (item.ticked) {denoms.push(item.Value)}})
    }
    let obj = {
      currentStats: 'authorizedResidual',
      searchText: this.model.searchText,
      branchId: this.model.branch,
      startDate: this.getStartDate(),
      endDate: this.getEndDate(),
      vaultDate: this.currentVaultDate,
      timezone: this.model.browserTimezone,
      fundingSource: this.model.fundingSource,
      denoms, user: this.model.user && this.model.user.Value ? this.model.user.Value : null,
      sectionType : 'atm'
    }

    let path = this.$state.href('printFinalResidualCountCommit');
    window.w = window.open(path, '_blank');
    window.w.printData = obj;
  }

  printAuthorizedDepositsResidual() {
    let denoms = [];
    if (this.model.denoms && this.model.denoms.length) {
      this.model.denoms.forEach(item => { if (item.ticked) { denoms.push(item.Value) } })
    }
    let obj = {
      currentStats: 'authorizedResidual',
      searchText: this.model.searchText,
      branchId: this.model.branch,
      startDate: this.getStartDate(),
      endDate: this.getEndDate(),
      vaultDate: this.currentVaultDate,
      timezone: this.model.browserTimezone,
      fundingSource: this.model.fundingSource,
      user: this.model.user && this.model.user.Value ? this.model.user.Value : null,
      denoms,
      sectionType: 'deposit'
    }

    let path = this.$state.href('printFinalResidualCountCommit');
    window.w = window.open(path, '_blank');
    window.w.printData = obj;
  }

  downloadFile(reportPrefix, reportData) {
    const fileName = reportPrefix.concat('.csv');
    const a = document.createElement("a");
    document.body.appendChild(a);
    const file = new Blob([reportData], { type: 'application/csv' });
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  }

  exportResidualsCompletedApproval() {

    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const reportPrefix = `Authorized_Residual_Count_${this.model.fundingSource.Value}_(${this.model.branch})`;
    let denoms = [];
    let user = this.model.user && this.model.user.Value ? this.model.user.Value : null;
    if (this.model.denoms && this.model.denoms.length ) {
      this.model.denoms.forEach(item => {if (item.ticked) {denoms.push(item.Value)}})
    }
    this.model.isExportingAuthorizedResidual = true;
    this.AtmResidualService.exportResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.browserTimezone, startDate, endDate, denoms, user, 0, 1000)
      .then((data) => {
        this.downloadFile(reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isExportingAuthorizedResidual = false;
      })
  }

  exportDepositsResidualsCompletedApproval() {
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    const reportPrefix = `Authorized_Deposits_Count_${this.model.fundingSource.Value}_(${this.model.branch})`;
    let denoms = [];
    let user = this.model.user && this.model.user.Value ? this.model.user.Value : null;
    if (this.model.denoms && this.model.denoms.length) {
      this.model.denoms.forEach(item => { if (item.ticked) { denoms.push(item.Value) } })
    }
    this.model.isDepositsAuthorizedResidualExporting = true;
    this.AtmResidualService.exportDepositsResidualsCompletedApproval(this.model.searchText, this.model.fundingSource.Id, this.model.browserTimezone, startDate, endDate, user, denoms, 0, 1000)
      .then((data) => {
        this.downloadFile(reportPrefix, data.reportData)
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.model.isDepositsAuthorizedResidualExporting = false;
      })
  }

  getStartDate() {
    return this.model.dateRangeOption.startDate ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
  }

  getEndDate() {
    return this.model.dateRangeOption.endDate ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;
  }

  loadAllDenomination() {
    return this.DenominationService.all(null, 0, 1000)
    .then((data) => {
      this.allDenominations = data.results.map(denom => ({
          ...denom,
          sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
      }));
      this.denomsList = this.mappingData(this.allDenominations, 'name', 'id');
      return this.denomsList;
    })
    .catch((err) => {
      console.log(err)
    })
  }

  mappingData(arr, label, value) {
    return arr.map((item) => {
        const arrayObject = {
            Key: item[value] + ' | ' + item[label],
            Value: item[value]
        };

        return arrayObject;
    });
  }

  userSearchObj = (searchKey) => {
    searchKey = searchKey || '';
    const searchObj = {
      queryJSON: {
        rules: [
          // {
          //   field: 'downloadToHHT',
          //   condition: '=',
          //   data: 1
          // },
          {
            field: 'branchId',
            condition: '=',
            data:  this.model.branch
          },
          {
            group: {
              rules: [{
                field: 'firstName',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'lastName',
                condition: 'like',
                data: '%' + searchKey + '%'
              },
              {
                field: 'id',
                condition: 'like',
                data: '%' + searchKey + '%'
              }
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  getResidualUsers(searchKey, offset) {
    if (!this.model.fundingSource) {
      this.model.userList = [];
      this.model.totalUsers = 0;
      this.model.user = null;
      return this.$q.resolve();
    }
    const branchId = this.model.branch;
    const fundingSourceId = this.model.fundingSource.Id;
    const startDate = !this.toggleSelect ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD 00:00:00') : null;
    const endDate = !this.toggleSelect ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD 23:59:59') : null;
    const status = this.model.currentStats;

    return this.AtmResidualService.getCountedUsers(branchId, fundingSourceId, startDate, endDate, searchKey, offset, AppConstants.defaultPageLimit, status)
      .then((data) => {
        const usersList = this.mappingUserData(data.results);
        if (offset === 0) {
          this.model.totalUsers = data.total;
          this.model.userList = usersList;
        } else {
          this.model.userList = this.model.userList.concat(usersList);
        }

        if (this.model.user && this.model.user.Value) {
          const exists = this.model.userList.some(u => u.Value === this.model.user.Value);
          if (!exists) {
            this.model.user = null;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  mappingUserData(arr) {
    return arr.map((item) => {
        const arrayObject = {
            Key: item.id + ' | ' + item.firstName + ' ' + item.lastName,
            Value: item.id
        };
        return arrayObject;
    });
  }
}

export default FinalResidualCountCommitController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/final_residual_count_commit.controller.js